import type { TimelineItem } from '@/types';

export const TIMELINE: TimelineItem[] = [
  {
    id:          'asterion-cnc-2023',
    dateRange:   'Jul. 2023 → Present',
    role:        'Quality & Maintenance Coordinator · Founder of Asterion Solutions',
    company:     'CNC Tracy Inc. & Asterion Solutions Inc.',
    location:    'Sorel-Tracy / Montreal, QC',
    description: 'Final PRIE/ITP inspections (Hexagon arm), complete quality packages, NDT coordination, ISO 9001 non-conformity management. Rebuilt the quality system and set up a CMMS tied into the Notixia ERP. In parallel: founder and lead developer of Asterion Solutions — an industrial B2B SaaS suite. OSEntreprendre 2026 laureate.',
    tags:        ['Hexagon · CMM', 'ISO 9001', 'CMMS · Notixia', 'React 19 · AI', 'OSEntreprendre 2026'],
    isCurrent:   true,
  },
  {
    id:          'usl-2019',
    dateRange:   'Jul. 2019 → Jul. 2023',
    role:        'Project Manager — Quality',
    company:     'Usinage Saint-Laurent',
    location:    'Sorel-Tracy, QC',
    description: 'End-to-end management of heavy-part refurbishment projects for hydroelectric dams (Hydro-Québec) and steel mills (crusher cones, muffles, support rollers). Dimensional and NDT inspections, quality packages, coordination between production, customers and subcontractors. Genius ERP.',
    tags:        ['Hydro-Québec', 'Heavy-part refurbishment', 'Genius ERP', 'GD&T · NDT'],
  },
  {
    id:          'cnc-2014',
    dateRange:   '2014 → 2019',
    role:        'Project Manager / Quality Assurance',
    company:     'CNC Tracy Inc.',
    location:    'Tracy, QC',
    description: 'Major quality projects for Andritz, GE, Voith and Toshiba. Building and validating quality packages, final inspections, non-conformity handling. Coordination between machining, customers and suppliers.',
    tags:        ['Andritz · GE · Voith · Toshiba', 'Final inspections', 'NCR · ISO'],
  },
  {
    id:          'cnc-machiniste-2012',
    dateRange:   '2012 → 2014',
    role:        'CNC Machinist',
    company:     'CNC Tracy Inc.',
    location:    'Tracy, QC',
    description: 'CNC machining (Mazak V655-60 / V515), dimensional inspection, assembly. First immersion in precision mechanics and hydroelectric work.',
    tags:        ['Mazak V655-60', 'CNC', 'Dimensional inspection'],
  },
  {
    id:          'dut-2012',
    dateRange:   '2012',
    role:        'Mechanical Engineering Diploma (DUT)',
    company:     'Université Paul Sabatier — Toulouse III',
    location:    'Toulouse, France',
    description: 'Technical training in mechanical engineering: tolerancing, manufacturing processes, industrial drawing, fluid mechanics. The foundation of everything that followed.',
    tags:        ['Toulouse · France', 'Mechanical Engineering', 'Equivalent to a Quebec technical DEC'],
    isEducation: true,
  },
];
